import React, { useEffect, useState } from 'react';
import logo from '../../assets/v_logo_loading_300x300.gif';
import './GalleryLoader.css';

const GalleryLoader = ({ images, onComplete }) => {
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    if (!images || images.length === 0) {
      onComplete();
      return;
    }

    let loaded = 0;
    const total = images.length;

    const finish = () => {
      setHiding(true);
      setTimeout(onComplete, 500);
    };

    images.forEach(src => {
      if (!src) {
        loaded++;
        if (loaded >= total) finish();
        return;
      }
      const img = new Image();
      img.onload = img.onerror = () => {
        loaded++;
        if (loaded >= total) finish();
      };
      img.src = src;
    });
  }, [images, onComplete]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`gallery-loader${hiding ? ' gallery-loader--hiding' : ''}`}>
      <img src={logo} alt="" className="gallery-loader__logo" />
    </div>
  );
};

export default GalleryLoader;
